import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { API_URI } from 'src/environments/environment';

const GOOGLE_HOSTS = [
  'identitytoolkit.googleapis.com',
  'securetoken.googleapis.com',
  'firebaseio.com',
  'firebaseinstallations.googleapis.com',
  'firestore.googleapis.com',
  'googleapis.com',
  'apis.google.com',
];

function isGoogleUrl(url: string): boolean {
  try {
    if (!/^https?:\/\//i.test(url)) return false; // relativas: no son Google
    const host = new URL(url).host.toLowerCase();
    return GOOGLE_HOSTS.some(d => host === d || host.endsWith('.' + d));
  } catch {
    return false;
  }
}

function shouldAttachAuthHeader(request: HttpRequest<unknown>): boolean {
  // No agregar nada a assets locales
  if (request.url.startsWith('/assets')) return false;
  // NO agregar nada a dominios de Google/Firebase
  if (isGoogleUrl(request.url)) return false;
  // Agregar auth SOLO a tu backend (API_URI)
  if (API_URI && request.url.startsWith(API_URI)) return true;

  return false;
}

function stripSensitiveHeaders(headers: HttpHeaders): HttpHeaders {
  // Elimina headers que pueden disparar preflights o credenciales
  const toDrop = ['Authorization', 'X-XSRF-TOKEN', 'cookie', 'Cookie'];
  let h = headers;
  toDrop.forEach(name => {
    if (h.has(name)) h = h.delete(name);
  });
  return h;
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (isGoogleUrl(request.url)) {
      const cleanRequest = request.clone({
        withCredentials: false,
        headers: stripSensitiveHeaders(request.headers),
      });

      return next.handle(cleanRequest);
    }

    let clonedRequest = request;
    // Obtener el token desde localStorage (o sessionStorage si se prefiere mayor seguridad)
    const tokenBackend = localStorage.getItem('tokenBackend');
    const tokenId = localStorage.getItem('tokenId');
    const token = tokenBackend || tokenId;

    if (token && shouldAttachAuthHeader(request)) {
      clonedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
        withCredentials: false,
      });
    }
    return next.handle(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if(error.status === 401){
          console.error('Autenticación fallida (401): Token no válido');
          localStorage.removeItem('tokenBackend'); // Eliminar token en caso de que haya expirado o sea inválido
          localStorage.removeItem('tokenId');
          this.router.navigate(['/sign-in']);
        }
        // Manejo de otros tipos de error (puedes agregar más condiciones si lo deseas)
        else if (error.status === 500) {
          console.error('Error del servidor');
          this.router.navigate(['/sign-in']);
        }
        else if (error.status === 403) {
          console.error('Auth fallida (403). Redirigiendo a inicio.');
          localStorage.removeItem('tokenBackend');
          localStorage.removeItem('tokenId');
          this.router.navigate(['/sign-in']);
        }
        /*else if (error.status === 404) {
          //console.error('Error de Not FOUND');
          if (request.url.includes('/app/ordenesComercio/xUsuario/')) {
            return throwError(() => error);  // No redirige, solo lanza el error
          }
          if (request.url.includes('/app/ordenesPrestador/xUsuario/')) {
            return throwError(() => error);  // No redirige, solo lanza el error
          }
          if (request.url.includes('/app/clientes/xId/')) {
              return throwError(() => error);  // No redirige, solo lanza el error
          }
          if (request.url.includes('/app/comercios/xId/')) {
              return throwError(() => error);  // No redirige, solo lanza el error
          }
          if (request.url.includes('/app/prestadores/xId/')) {
              return throwError(() => error);  // No redirige, solo lanza el error
          }
          this.router.navigate(['/sign-in']);
        }*/
        return throwError(() => error);
      })
    );
  }
}
